import { render, staticRenderFns } from "./MissWordV.vue?vue&type=template&id=3cebe27c"
import script from "./MissWordV.vue?vue&type=script&lang=js"
export * from "./MissWordV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MissWordV.vue?vue&type=custom&index=0&blockType=stype&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports